import { Abi } from 'viem'
import { useAccount, useWaitForTransactionReceipt, useWriteContract } from 'wagmi'

import { useValueTokens } from '@/contexts/VaultTokensContext'
import seaAVAX from '@/contracts/seaAVAX'

const useRedeemAVAX = (amount: bigint) => {
  const { chain } = useAccount()
  const { currentToken } = useValueTokens()
  // const { data: amountToSharesData } = useConvertToShares(amount)

  const {
    writeContract: writeContract,
    data: hash,
    isPending,
    error: writeError,
  } = useWriteContract()

  const {
    isLoading,
    isSuccess,
    data: receipt,
    isError,
  } = useWaitForTransactionReceipt({
    hash,
  })

  const handleWrite = async () => {
    const contractData: any = {
      abi: seaAVAX as Abi,
      address: currentToken.tokenAddresses[1][chain?.id] as `0x${string}`,
      functionName: 'redeemAVAX',
      args: [amount],
    }
    writeContract({
      ...contractData,
    })
  }

  return {
    hash,
    isPending,
    writeError,
    isLoading,
    isSuccess,
    receipt,
    isError,
    redeem: () => handleWrite(),
  }
}

export default useRedeemAVAX
